module.exports = __webpack_public_path__ + "img/coach-profile-banner.37632d81.jpg";